import React from 'react'
import { Autocomplete, Box, Button, CircularProgress, Grid, Paper, TextField, Tooltip, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { fieldDateFormat } from '../../../constants'
import moment from 'moment'
import { InfoOutlined } from '@mui/icons-material'

const FilterCard = ({ dropDownLoader, onFieldChange, onFocusChange, filterData, error, onApplyFilter, onResetFilter, currencies = [] }) => {
  const currencyOptions = currencies.map((currency) => ({ label: currency?.name, value: currency?.id }))
  return (
    <Paper sx={{ padding: 2, background:'EAEAEA',margin:1 }}>
      <Grid container spacing={1} alignItems="stretch">
        <Grid size={{ md: 10, xs: 12 }}>
          <Grid container spacing={1} alignItems="stretch">
            <Grid size={{ md: 4, xs: 12 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  required
                  label="Date From"
                  value={filterData?.date_from ? moment(filterData.date_from) : null}
                  onChange={(data, value) => {
                    onFieldChange("date_from", data);
                    onFocusChange("date_from");
                  }}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      size: "small",
                      margin: "normal",
                      helperText: error?.date_from,
                      error: error?.date_from,
                      onFocus: () => { onFocusChange("date_from") }
                    },
                    field: {
                      clearable: true,
                      onClear: () => {
                        onFieldChange("date_from", null);
                      }
                    },
                  }}
                  sx={{ width: "100%" }}
                  format={fieldDateFormat}
                  maxDate={filterData?.date_to ? moment(filterData?.date_to) : null}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  required
                  label="Date To"
                  value={filterData?.date_to ? moment(filterData.date_to) : null}
                  // onChange={(data, value) => onFieldChange('date_to', moment(data).format(backendDateFormat))}
                  onChange={(data, value) => {
                    onFieldChange("date_to", data);
                    onFocusChange("date_to");
                  }}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      size: "small",
                      margin: "normal",
                      helperText: error?.date_to,
                      error: error?.date_to,
                      onFocus: () => { onFocusChange("date_to") }
                    },
                    field: {
                      clearable: true,
                      onClear: () => {
                        onFieldChange("date_to", null);
                      }
                    },
                  }}
                  sx={{ width: "100%" }}
                  format={fieldDateFormat}
                  minDate={filterData?.date_from ? moment(filterData?.date_from) : null}
                />

              </LocalizationProvider>
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                options={currencyOptions}
                disabled={dropDownLoader?.display_currency}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                noOptionsText={dropDownLoader?.display_currency ? "Loading..." : "No Option Available"}
                getOptionLabel={(option) => option.label || ""}
                value={filterData?.display_currency_id || null}
                onChange={(e, value) => onFieldChange("display_currency_id", value)}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                      <TextField
                        {...params}
                        label="Display Currency"
                        margin='normal'
                        size='small'
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                          input: {
                            ...params?.InputProps, endAdornment: <>{dropDownLoader?.display_currency && <CircularProgress color="inherit" size={20} />}
                              {params?.InputProps?.endAdornment}
                            </>
                          }
                        }}
                      />
                    </Tooltip>)
                }}
              />
            </Grid>
            {/* <Grid size={{ md: 3, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={[{ label: 'No Comparision', value: 1 }, { label: 'Previous Period', value: 2 }, { label: 'Previous Year', value: 3 }]}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                // noOptionsText={dropDownLoader?.display_currency ? "Loading..." : "No Option Available"}
                getOptionLabel={(option) => option.label || ""}
                value={filterData?.comparision || null}
                onChange={(e, value) => onFieldChange("comparision", value)}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                      <TextField
                        {...params}
                        label="Comparision"
                        margin='normal'
                        size='small'
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                        }}
                      />
                    </Tooltip>)
                }}
              />
            </Grid> */}
          </Grid>
        </Grid>
        <Grid size={{ md: 2, xs: 12 }} >
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start', gap: '8px',paddingTop:5 }}>
            <Button variant='contained' size='small' onClick={onApplyFilter} disabled={!(filterData?.date_from || filterData?.date_to || filterData?.display_currency_id )}>Apply</Button>
            <Button variant='outlined' size='small' onClick={onResetFilter} disabled={!(filterData?.date_from || filterData?.date_to || filterData?.display_currency_id )}>Reset</Button>
          </div>
        </Grid>
      </Grid>
      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, mt: 1.5, px: 1, py: 0.5, borderRadius: 2, bgcolor: "#FFF8E1", border: "1px solid #FFE082", color: "#8A6D1D", }} >
        <InfoOutlined sx={{ fontSize: 16 }} />
        <Typography fontSize='11px'>
          By default, data from the last <strong>1 year</strong> is displayed when no date filters are applied.
        </Typography>
      </Box>
    </Paper>
  )
}

export default FilterCard